import {
  freeUploadWeekStartMs,
  nextFreeUploadResetMs,
} from '@listening/api-contract';
import { useSyncExternalStore } from 'react';

const readWeekStartMs = () => freeUploadWeekStartMs(Date.now());

const subscribeToWeeklyReset = (onChange: () => void) => {
  let id: ReturnType<typeof setTimeout> | undefined;
  const scheduleNextReset = () => {
    const nowMs = Date.now();
    id = setTimeout(
      () => {
        onChange();
        scheduleNextReset();
      },
      nextFreeUploadResetMs(nowMs) - nowMs,
    );
  };
  scheduleNextReset();
  return () => {
    clearTimeout(id);
  };
};

export const useFreeUploadWeekStartMs = () =>
  useSyncExternalStore(
    subscribeToWeeklyReset,
    readWeekStartMs,
    readWeekStartMs,
  );
